import pick from 'lodash/fp/pick';
import groupBy from 'lodash/fp/groupBy';
import mapValues from 'lodash/fp/mapValues';
import {connect} from 'react-redux';
import {getStatus, getResources} from 'redux-resource';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import mapProps from 'recompose/mapProps';
import withLoadingIndicator from '../../../common/with-loading-indicator/index';
import {readCollections} from '../../../../redux/actions/collections';
import {readAllFiles} from '../../../../redux/actions/files';
import List from './list';

const aggregateFilesByCollection = compose(
	mapValues('length'),
	groupBy('collection'),
);

function mapStateToProps(state) {
	const status = getStatus(state, [
		'collections.requests.all.status',
		'files.requests.all.status'
	]);
	const items = getResources(state.collections, 'all');
	const filesCount = aggregateFilesByCollection(getResources(state.files, 'all'));
	const language = state.languages.switchValue;

	return {
		status,
		items,
		filesCount,
		language
	};
}

function mapDispatchToProps(dispatch) {
	return {
		readList: () => {
			dispatch(readCollections());
			dispatch(readAllFiles());
		}
	};
}

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	lifecycle({
		componentDidMount() {
			this.props.readList();
		}
	}),
	withLoadingIndicator,
	mapProps(pick([
		'items',
		'filesCount',
		'handleShowFiles',
		'language'
	]))
);

export default enhance(List);



// WEBPACK FOOTER //
// ./src/client/components/main/collections/list/index.js